// extracted by mini-css-extract-plugin
module.exports = {"item":"A858QQ","titleItem":"GAa_KB","info":"_958W4g","name":"JnKUU8","latestName":"vVRPl9","date":"MRTXDU","readNow":"AOGUXI"};